export default class StickyFooter {
  constructor() {

    if (document.documentElement.classList.contains('page--blue')) {
      return;
    }

    this.footer = document.getElementById("footer");
    this.main = document.getElementById("main");
    this.header = document.getElementById('site-header');

    if(!this.footer || !this.main || !this.header) {
      return;
    }

    this.clientHeight = window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;



    this.setStyles();
    this.updateViewport();
  }

  /**
   * Set footer styles
   */
  setStyles() {
    const height = (this.footer.offsetHeight - 30);
    const offsetHeight = this.header.offsetHeight + 24; // header-height + #main padding-top

    if(
      this.main.offsetHeight > this.clientHeight
      && this.footer.offsetHeight < (this.clientHeight - offsetHeight)
      && this.clientHeight > height
      && window.matchMedia('(min-width: 991px)').matches
    ) {
      document.body.style.paddingBottom = height + "px";
      this.footer.style.position = 'fixed';
    } else {
      document.body.style.paddingBottom = '';
      this.footer.style.position = '';
    }
  }

  /**
   * Update on viewport
   */
  updateViewport() {
    window.addEventListener('orientationchange', () => {
      this.setStyles();
    });
    window.addEventListener('resize', () => {
      this.setStyles();
    });
  }
}
